module.exports = __webpack_public_path__ + "img/shirotchampi.1a396124.jpg";